import { useQuery } from "@tanstack/react-query"
import type { UseQueryResult } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"
import type {
  BatteryProposalTariffCandidateDto,
  BatteryProposalUtilityCompanyDto,
} from "~/api/dto/battery-proposal.dto"
import { batteryProposalService } from "~/api/services/battery-proposal.service"

export default function useBatteryProposalUtilityOptions(
  proposalId: string,
  editing: boolean,
  lseId: number | null,
): {
  companies: UseQueryResult<BatteryProposalUtilityCompanyDto[], unknown>
  tariffs: UseQueryResult<BatteryProposalTariffCandidateDto[], unknown>
} {
  const companies = useQuery({
    queryKey: queryKeys.batteryProposal.utilityCompanies(proposalId),
    queryFn: () => batteryProposalService.getUtilityCompanies(proposalId),
    enabled: editing,
    staleTime: 5 * 60 * 1000,
  })
  const tariffs = useQuery({
    queryKey: queryKeys.batteryProposal.utilityTariffs(proposalId, lseId),
    queryFn: () =>
      lseId == null
        ? Promise.resolve([])
        : batteryProposalService.getUtilityTariffs(proposalId, lseId),
    enabled: editing && lseId != null,
    staleTime: 5 * 60 * 1000,
  })
  return { companies, tariffs }
}
